import { useState, useEffect } from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';
import WhatsAppFloat from '@/components/layout/WhatsAppFloat';
import ScrollToTop from '@/components/layout/ScrollToTop';
import CartDrawer from '@/sections/CartDrawer';
import HeroSection from '@/sections/HeroSection';
import MissionSection from '@/sections/MissionSection';
import CoffeeTourSection from '@/sections/CoffeeTourSection';
import GalleryMasonry from '@/sections/GalleryMasonry';
import ContactSection from '@/sections/ContactSection';
import MapSection from '@/sections/MapSection';
import BuySection from '@/sections/BuySection';

function App() {
  const [scrolled, setScrolled] = useState(false);
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 100, damping: 30, restDelta: 0.001 });

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative min-h-screen bg-coffee-50 overflow-x-hidden">
      {/* Progress bar */}
      <motion.div
        className="fixed top-0 left-0 right-0 h-1 bg-gradient-to-r from-coffee-400 via-terracotta-400 to-coffee-400 origin-left z-[60]"
        style={{ scaleX }}
      />
      
      <Navbar scrolled={scrolled} />
      
      <main>
        <section id="home"><HeroSection /></section>
        <section id="about"><MissionSection /></section>
        <section id="coffeetour"><CoffeeTourSection /></section>
        <section id="buy"><BuySection /></section>
        <section id="gallery"><GalleryMasonry /></section>
        <section id="contact"><ContactSection /></section>
        <section id="map"><MapSection /></section>
        
      </main>
      
      <Footer />
      <WhatsAppFloat />
      <ScrollToTop />
      <CartDrawer />
    </div>
  );
}

export default App;
